import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { getVideoSrc } from 'media/utils/getVideoSrc/getVideoSrc'
import type { DamFeatureFlagVariables } from '../../../types/types'
import { getLegacyVideoSrc } from '../../../utils/getLegacyVideoSrc/getLegacyVideoSrc'

interface UseVideoUrlProps {
	src: string
}
export const useVideoUrl = ({ src }: UseVideoUrlProps) => {
	const { variables } = useFeatureFlag<DamFeatureFlagVariables>(
		featureFlagKeys.Dam
	)

	return {
		videoSrc: variables.isVideoEnabled
			? getVideoSrc(src).href
			: getLegacyVideoSrc(src).href,
	}
}
